import { useEffect, useRef } from "react";
import * as Vlab from "vlab-frontend-components";
import { useTranslation } from "react-i18next";
import { tokenStore } from "../shared/auth/tokenStore";
import { IAM_URL } from "../utils/constants";

export const useExpiredTokenListener = () => {
  const { enqueueSnackbar } = Vlab.Notistack.useSnackbar();
  const { t } = useTranslation();
  const handlingRef = useRef(false);

  useEffect(() => {
    const handleTokenExpired = () => {
      if (handlingRef.current) return;
      handlingRef.current = true;
      enqueueSnackbar(
        t('expiredToken'),
        { variant: 'error', autoHideDuration: 5000 }
      );
      setTimeout(() => {
        tokenStore.clear();
        window.location.href = `${IAM_URL}/#/logout`;
        handlingRef.current = false;
      }, 5000);
    };

    window.addEventListener('tokenExpired', handleTokenExpired);
    return () => {
      window.removeEventListener('tokenExpired', handleTokenExpired);
    };
  }, [t, enqueueSnackbar]);
};
